import React from 'react';
import styles from './ReportCardCompleteCount.module.scss';
import { Tooltip } from 'antd';

export const ReportCardCompleteCount = ({
  planCount = '',
  factCount = '',
  closeCount = '',
}) => {
  const conditions = [
    { value: planCount, label: 'План' },
    { value: factCount, label: 'Факт' },
    { value: closeCount, label: 'Закрытые' },
  ].filter(
    ({ value }) => value !== undefined && value !== null && value !== ''
  );

  return (
    <div>
      {conditions.length > 0 ? (
        conditions.map(({ value, label }, index) => (
          <React.Fragment key={label}>
            <Tooltip
              placement="top"
              title={label}
            >
              <span className={styles.totalRequests}>{value}</span>
            </Tooltip>
            {index < conditions.length - 1 && (
              <span className={styles.totalRequests}>/</span>
            )}
          </React.Fragment>
        ))
      ) : (
        <span className={styles.totalRequests}>0</span>
      )}
    </div>
  );
};
